export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'
export const nosotrasurl =
  {
    'es-CL': 'nosotrasonline.cl',
  }[LOCALE] || 'nosotrasonline.com.' + LOCALE.split('-')[1].toLowerCase()

export const HAVE_TOP = !['es-AR', 'es-UY'].includes(LOCALE)
export const NO_REDIME = ['es-BO', 'es-UY'].includes(LOCALE)
export const concourseId = {
  DEV: {
    'es-CO': 581,
    'es-DO': 588,
  },
  PDN: {
    'es-CO': 691,
    'es-DO': 705,
  },
}[ENV || 'DEV'][LOCALE || 'es-CO']

export const costHelpActivity = 10

export const gameId = {
  DEV: {
    'es-CO': 220,
    'es-DO': 227,
  },
  PDN: {
    'es-CO': 227,
    'es-DO': 235,
  },
}[ENV || 'DEV'][LOCALE || 'es-CO']

export const costActivity =
  {
    'es-CO': 20,
  }[LOCALE] || 20

// WILL COME FOR BD
export const activity_dates = ['xx-01-xxxx', 'xx-01-xxxx']

export const topNumber =
  {
    'es-CO': 50,
  }[LOCALE] || 10

export const pointsForVideoWatched = 6

export const LOCALE_AT = {
  ARGENTINA: LOCALE === 'es-AR',

  BOLIVIA: LOCALE === 'es-BO',

  ECUADOR: LOCALE === 'es-EC',

  PERU: LOCALE === 'es-PE',

  CHILE: LOCALE === 'es-CL',
  URUGUAY: LOCALE === 'es-UY',

  DOMINICANA: LOCALE === 'es-DO',
  PUERTO_RICO: LOCALE === 'es-PR',
  PARAGUAY: LOCALE === 'es-PY',
}

export const cost_respawn = 5

const DEFAULT_STICKER_LINK = 'https://sticker.ly/s/U85J4C'

export const activity_stickers_link =
  {
    'es-CO': DEFAULT_STICKER_LINK,
    'es-AR': 'https://sticker.ly/s/9GZNS9',
    'es-PY': 'https://sticker.ly/s/9GZNS9',
    'es-UY': 'https://sticker.ly/s/9GZNS9',
  }[LOCALE] || DEFAULT_STICKER_LINK

export const SHOW_STORE_PACKAGE_MESSAGE = ![
  'es-AR',
  'es-PY',
  'es-UY',
  'es-CL',
].includes(LOCALE)

export const pointsToRevive = 5
